import { createAction } from 'redux-action';

export const CHANGE_MODE = 'addon/mode/CHANGE';
export const changeMode = createAction(CHANGE_MODE);
